import { useSelector } from "react-redux";
import styles from './ColorDropdown.module.css';

export default function ColorDropdown({ handleColorDropdownSelect, seriesIds, label, value, column, filterBy }) {
  // get data from Redux state
  const uniqueOptions = {};
  const ucFirst = s => (s ?? "").toString().replace(/^./, c => c.toUpperCase());

  let data = useSelector((state) => {
    const ids = Array.isArray(seriesIds) ? seriesIds : [seriesIds];
    // Convert each series' object-of-products into an array of product objects
    return ids.flatMap((id) =>
        Object.values(state.visualizer.productDataBySeries[id] || {})
      );
  }) || [];

  // Apply filtering if filterBy is provided
  if (filterBy) {
    data = data.filter(item => {
      return Object.entries(filterBy).every(([key, val]) => {
        // Skip if filter value is -1 (All)
        if (val === -1 || val === '-1') return true;
        return item[key] === val;
      });
    });
  }

  // Now each item is an individual product object
  data.forEach((obj) => {

    let colorName = obj[column];
    if (colorName == null || colorName === "") return;
    colorName.split('&').forEach((color) => {
      color = color.toLowerCase();
      color = color.trim();
      if (!Object.hasOwn(uniqueOptions, color)) {
        uniqueOptions[color] = colorName;
      }
    });
  });


  // uniqueOptions: { [value]: label }
  const dropdownOptions = Object.entries(uniqueOptions).map(([label, value]) => (
    <option key={value} value={value}>
      {ucFirst(label)}
    </option>
  ));

  return (
    <select
      name={column}
      className={styles.dropdown}
      value={value}
      onChange={handleColorDropdownSelect}
    >
      <option value="-1">All {label}</option>
      {dropdownOptions}
    </select>
  );
}
